(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'recently_viewed_products';
      // Matches MAX_ITEMS in the recording script in layout/theme.liquid —
      // there's never more than this many handles in storage to begin with.
      this.maxDisplay = 10;
    }

    connectedCallback() {
      // Starts hidden (display: none) until populated, so it can never intersect
      // the viewport — render eagerly instead of lazy-loading on scroll.
      this.renderProducts();
    }

    getHandles() {
      try {
        const stored = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        return Array.isArray(stored) ? stored : [];
      } catch (error) {
        return [];
      }
    }

    async renderProducts() {
      const handles = this.getHandles()
        .filter((handle) => handle !== this.dataset.currentHandle)
        .slice(0, this.maxDisplay);

      if (!handles.length) return;

      // Fetch the real card-product markup via the Section Rendering API so
      // recently-viewed cards always match the rest of the site exactly
      // (LINE price, sale/sold-out badges, quantity ribbon, etc.).
      const cardsHtml = (
        await Promise.all(
          handles.map((handle) =>
            fetch(`/products/${encodeURIComponent(handle)}?section_id=recently-viewed-card`)
              .then((response) => (response.ok ? response.text() : null))
              .catch(() => null)
          )
        )
      ).filter(Boolean);

      if (!cardsHtml.length) return;

      const list = this.querySelector('[data-recently-viewed-list]');
      if (!list) return;

      // Switch to a horizontally-scrolling slider instead of wrapping to
      // extra rows once there are more cards than fit in one row.
      const columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 4;
      const columnsMobile = parseInt(this.dataset.columnsMobile, 10) || 2;
      const isDesktopSlider = cardsHtml.length > columnsDesktop;
      const isMobileSlider = cardsHtml.length > columnsMobile;
      const useSlider = isDesktopSlider || isMobileSlider;
      const slideIdPrefix = list.id.replace(/^Slider-/, 'Slide-');

      list.innerHTML = cardsHtml
        .map((html, index) => {
          const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.card-wrapper');
          if (!card) return '';
          const slideClass = useSlider ? ' slider__slide' : '';
          return `<li id="${slideIdPrefix}-${index + 1}" class="grid__item${slideClass}">${card.outerHTML}</li>`;
        })
        .join('');

      if (isDesktopSlider) list.classList.add('slider', 'slider--desktop');
      if (isMobileSlider) list.classList.add('slider', 'slider--tablet', 'grid--peek');

      if (useSlider) {
        const buttons = this.querySelector('[data-recently-viewed-slider-buttons]');
        if (buttons) {
          buttons.hidden = false;
          const total = buttons.querySelector('.slider-counter--total');
          if (total) total.textContent = cardsHtml.length;
        }
        const sliderComponent = this.querySelector('slider-component');
        if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
          sliderComponent.resetPages();
        }
        this.enableDragToScroll(list);
      }

      this.hidden = false;
    }

    // component-slider.css hides the native scrollbar, and a mouse (unlike a
    // trackpad or touchscreen) has no built-in way to pan it horizontally —
    // so without this, the prev/next buttons are the only way to scroll with
    // a mouse. Click-and-drag support fixes that.
    enableDragToScroll(slider) {
      let dragging = false;
      let moved = false;
      let startX = 0;
      let startScrollLeft = 0;

      slider.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScrollLeft = slider.scrollLeft;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(event.pointerId);
        // Without this, starting the drag on a card image triggers the
        // browser's native image-drag instead — which steals the pointer
        // events (no further pointermove/pointerup ever fires here) and
        // leaves `dragging` stuck true, breaking every drag after the first.
        event.preventDefault();
      });

      slider.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 3) moved = true;
        slider.scrollLeft = startScrollLeft - delta;
        // slider-component listens for 'scroll' to update the counter/button
        // state; dispatch explicitly in case a programmatic scrollLeft
        // change doesn't reliably fire it on its own.
        slider.dispatchEvent(new Event('scroll'));
      });

      const stopDragging = (event) => {
        if (!dragging) return;
        dragging = false;
        slider.classList.remove('is-dragging');
        if (slider.hasPointerCapture(event.pointerId)) {
          slider.releasePointerCapture(event.pointerId);
        }
      };

      slider.addEventListener('pointerup', stopDragging);
      slider.addEventListener('pointercancel', stopDragging);
      // Failsafe: guarantee `dragging` always clears even if the pointerup
      // never reaches the slider itself for some reason.
      window.addEventListener('pointerup', stopDragging);

      // Don't let the drag gesture also act as a click-through to whichever
      // product card it happens to end on.
      slider.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        },
        true
      );
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);

  } catch(e) { console.error(e); }
})();
})();
